// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_customer_perks";

// function HomeSection12() {
//   const [perks, setPerks] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchPerks = async () => {
//       try {
//         const response = await axios.get(API_URL);

//         console.log("API RESPONSE:", response.data);

//         if (response.data && Array.isArray(response.data.data)) {
//           setPerks(response.data.data);
//         } else {
//           setPerks([]);
//         }
//       } catch (error) {
//         console.error("Error fetching perks:", error);
//         setPerks([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPerks();
//   }, []);

//   return (
//     <div className="container-fluid pt-4 pb-2 backsection_col mt-5">
//       <div className="row text-center text-md-start mx-5">

//         {loading && <p>Loading...</p>}

//         {!loading && perks.length === 0 && (
//           <p>No perks found</p>
//         )}

//         {!loading &&
//           perks.map((item) => (
//             <div
//               key={item.id}
//               className="col-12 col-sm-6 col-lg-3 col-md-3 col-xl-3 mb-4"
//             >
//               <div className="d-flex align-items-start">
//                 <i className="bi bi-truck text-light fs-5 me-3 icon-square1"></i>
//                 <div>
//                   <h6 className="mb-1 text-start fw-bold">
//                     {item.heading}
//                   </h6>
//                   <small className="mb-0 text-muted text-start">
//                     {item.description}
//                   </small>
//                 </div>
//               </div>
//             </div>
//           ))}
//       </div>
//     </div>
//   );
// }

// export default HomeSection12;


import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL =
  "https://ecom.cyberathon.com/index.php/Api/list_customer_perks";

function HomeSection12() {
  const [perks, setPerks] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static icon + color config (No backend change needed)
  const iconConfig = [
    { icon: "bi-truck", className: "icon-square1" },
    { icon: "bi-credit-card", className: "icon-square2" },
    { icon: "bi-gift", className: "icon-square3" },
    { icon: "bi-people", className: "icon-square4" },
  ];

  useEffect(() => {
    const fetchPerks = async () => {
      try {
        const response = await axios.get(API_URL);

        if (response.data && Array.isArray(response.data.data)) {
          setPerks(response.data.data);
        } else {
          setPerks([]);
        }
      } catch (error) {
        console.error("Error fetching perks:", error);
        setPerks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPerks();
  }, []);

  return (
    <div className="container-fluid pt-5 pb-2 backsection_col mt-md-3 mt-0">
      <div className="row text-center text-md-start mx-5">

        {/* Loading */}
        {loading && (
          <div className="text-center w-100">
            <p>Loading...</p>
          </div>
        )}

        {/* Show Only First 4 Perks */}
        {!loading &&
          perks.slice(0, 4).map((item, index) => {
            const config = iconConfig[index] || iconConfig[0];

            return (
              <div
                key={item.id}
                className="col-12 col-sm-6 col-lg-3 col-md-3 col-xl-3 mb-4"
              >
                <div className="d-flex align-items-start">

                  {/* Dynamic Icon + Color */}
                  <i
                    className={`bi ${config.icon} text-light fs-5 me-3 ${config.className}`}
                  ></i>

                  <div>
                    <h6 className="mb-1 text-start fw-bold">
                      {item.heading}
                    </h6>
                    <small className="mb-0 text-muted text-start">
                      {item.description}
                    </small>
                  </div>

                </div>
              </div>
            );
          })}

        {/* No Data */}
        {!loading && perks.length === 0 && (
          <div className="text-center w-100">
            <p>No perks available</p>
          </div>
        )}

      </div>
    </div>
  );
}

export default HomeSection12;
